import { render, staticRenderFns } from "./FormPolizaCancelacion.vue?vue&type=template&id=c95a4c7e"
import script from "./FormPolizaCancelacion.vue?vue&type=script&lang=js"
export * from "./FormPolizaCancelacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports